import React from 'react';
import styles from './FooterN.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <footer className={cx('footer')}>
      <div className={cx('container footer-inner')}>
        <div className={cx('footer-logo')}>ETERINFO</div>
        <div className={cx('footer-text')}>
          <p>©2018-2026 ETERINFO. All rights reserved.</p>
          {/* <p><a href="mailto:aliswell86@naver.com')}>aliswell86@naver.com</a></p> */}
        </div>
        {/* <div className={cx('footer-img')}> */}
          {/* <img src="dark-logo.png" alt="Footer Logo" /> */}
        {/* </div> */}
      </div>
    </footer>
    // <footer className={cx(cx('footer')}>
    //   <div>&copy;2018-2022 ETERINFO. Data based on</div>
    //   <div><a rel="noopener noreferrer" target="_blank" href="http://eternalcity.mgame.com/">이터널시티.</a></div>
    //   <div>aliswell86@naver.com</div>
    // </footer>
  );
};

export default Footer;